<template>
    <v-snackbar
      v-model="showNotification"
      :color="isOnline ? 'success' : 'warning'"
      :timeout="4000"
      top
    >
      <v-icon left>
        {{ isOnline ? 'mdi-wifi' : 'mdi-wifi-off' }}
      </v-icon>
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="showNotification = false"
        >
          Sluiten
        </v-btn>
      </template>
    </v-snackbar>
</template>

<script>
import { EventBus } from '@/utils/eventBus'
import networkStatus from '@/utils/networkStatus'

export default {
  name: 'NetworkStatus',
  data () {
    return {
      showNotification: false,
      isOnline: true,
      message: ''
    }
  },
  mounted () {
    this.isOnline = networkStatus.isOnline()

    EventBus.$on('network-status-changed', (online) => {
      this.isOnline = online
      this.message = online
        ? 'Verbinding hersteld - Gegevens worden gesynchroniseerd'
        : 'Geen internetverbinding - Wijzigingen worden lokaal opgeslagen'
      this.showNotification = true
    })
  },
  beforeDestroy () {
    EventBus.$off('network-status-changed')
  }
}
</script>
